import React from "react";
import * as Tooltip from "@radix-ui/react-tooltip";

const LightTooltip = ({ title, children, side = "bottom" }) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Content
          side={side}
          className="bg-white text-black text-[13px] shadow-md px-2.5 py-1.5 rounded-md z-50"
        >
          {title}
          <Tooltip.Arrow className="fill-white shadow-md" />
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export { LightTooltip };
